export default __webpack_public_path__ + "static/media/mena14.3b037e1b.PNG";